import React, { useState } from 'react';
import { SelectMulti, IconButton, Button } from 'htlib-copy';
import { func, string } from 'prop-types';

import customTypes from 'types';
import { entitiesToSelectItems } from 'utils/select';
import { useGetSingleCheck } from 'hooks/checks';
import AsyncUI from 'components/AsyncUI';

import { useUrlParam } from '../utils';
import ActionButtons from './ActionButtons';
import { formatPayloadForMission, indexEntities } from './utils';

export default function ActionMultilabel({ checkId, indexName, entities, patchChecks }) {
  const formatPayloadMultilabel = formatPayloadForMission(entities, 'multilabel', indexName);
  const { getUrlParam } = useUrlParam();
  const entityId = getUrlParam('entity');
  const tagValue = getUrlParam('tags');

  const [selectedEntityIds, setSelectedEntityIds] = useState([]);
  const [showSelect, setShowSelect] = useState(false);
  const [valueToTag, setValueToTag] = useState(null);
  const singleCheckQuery = useGetSingleCheck(
    checkId,
    { projection: 'labeling,check' },
    {
      enabled: Boolean(showSelect || valueToTag),
      onSuccess({ check: { labeling, check = {} } }) {
        if (valueToTag) {
          const payload = Object.entries({ ...labeling, ...check }).reduce(
            (acc, [eid, value]) => [
              ...acc,
              { entityId: eid, value: eid === entityId ? valueToTag : value },
            ],
            [],
          );
          patchChecks(payload);
          setShowSelect(false);
          setValueToTag(null);
        } else {
          const yesEntities = Object.entries({ ...labeling, ...check }).reduce(
            (acc, [eid, value]) => (value === 'yes' ? [...acc, eid] : acc),
            [],
          );
          setSelectedEntityIds(yesEntities);
        }
      },
    },
  );

  return (
    <div className="Action">
      {tagValue !== 'no_for_all' && <ActionButtons sendCheck={setValueToTag} />}

      {showSelect ? (
        <div className="Action__select">
          <AsyncUI query={singleCheckQuery}>
            <SelectMulti
              withSearch
              placeholder="- Entities -"
              items={entitiesToSelectItems(indexEntities(entities, indexName))}
              checkedItems={selectedEntityIds}
              onSelect={setSelectedEntityIds}
            />
          </AsyncUI>
          <div className="Action__confirm">
            <IconButton
              icon="cancel"
              onClick={() => {
                setSelectedEntityIds([]);
                setShowSelect(false);
              }}
            />
            {tagValue !== 'no_for_all' && (
              <Button
                type="warn"
                onClick={() => {
                  patchChecks({ noForAll: true });
                  setSelectedEntityIds([]);
                  setShowSelect(false);
                }}
              >
                No for all
              </Button>
            )}
            <IconButton
              icon="confirm"
              onClick={() => {
                patchChecks(formatPayloadMultilabel(selectedEntityIds));
                setSelectedEntityIds([]);
                setShowSelect(false);
              }}
            />
          </div>
        </div>
      ) : (
        <div className="Action__option">
          <Button
            type="primary"
            ghost
            onClick={() => {
              setShowSelect(true);
            }}
          >
            Add tag
          </Button>
        </div>
      )}
    </div>
  );
}

ActionMultilabel.propTypes = {
  entities: customTypes.misc.missionEntities.isRequired,
  indexName: string.isRequired,
  patchChecks: func.isRequired,
  checkId: string.isRequired,
};
